import { useMutation } from 'hooks/useMutation'
import { useQueryClient } from 'hooks/useQueryClient'

import { Data } from 'types/query'

type PostCompletionParams = {
  completionId: string | undefined
}

export const useCompletionComment = ({ completionId }: PostCompletionParams) => {
  const queryClient = useQueryClient()

  const optimisticIncrement = async () => {
    queryClient.setQueryData(['completion', [completionId]], (data: Data) => {
      if (data) {
        // eslint-disable-next-line no-param-reassign
        data.commentsCount = data.commentsCount ? data.commentsCount + 1 : 1
      }
      return data
    })
  }

  const addComment = useMutation(() => (completionId ? optimisticIncrement() : Promise.reject()), {
    retry: 3,
    onError: () => {
      queryClient.setQueryData(['completion', [completionId]], (data: Data) => {
        if (data) {
          // eslint-disable-next-line no-param-reassign
          data.commentsCount = data.commentsCount ? data.commentsCount + 1 : 1
        }
        return data
      })
    },
  })

  return {
    addComment,
  }
}
